import styled from 'styled-components';

export const StyledGiftOrderingWrapper = styled.div`
  width: 100%;
`;

export const StyledGiftOrderingContentWrapper = styled.div`
  padding: ${({ theme }) => `0 ${theme.space[4]}px ${theme.space[4]}px ${theme.space[4]}px`};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => `${theme.spacing['12']}`};
`;
